import {IArenaGameFiltersCategory} from "../arena-filters/categories/arena-game-filters-category.interface";
import {CategoryDefinitionId, IFilterCategoryDefinition} from "./filter-category-definition.interface";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {OtherFilterDefinition} from "../filters-definitions/other/other.filter-definition";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {ApplyGameFilterResult} from "../evaluators/game-filter-evaluator.interface";

export class OtherFiltersCategoryDefinition implements IFilterCategoryDefinition {

    constructor(otherAvailableCategories: IArenaGameFiltersCategory[],
                private readonly services: IServiceFactoryExtended) {
        this.availableFilters = [
            new OtherFilterDefinition(services, otherAvailableCategories)
        ];
    }

    readonly id: CategoryDefinitionId = null;

    applyFilters(gameInfo: GameInfo, filters: IGameFilterDefinition[]): ApplyGameFilterResult {
        return this.availableFilters[0].applyFilter(gameInfo);
    }

    get title(): string {
        return this.services.translation.translate('OTHER');
    }

    readonly availableFilters: IGameFilterDefinition[];

    get isMultiSelect(): boolean {
        return false;
    }

    readonly hasItsOwnFiltersOrder = false;
}